import { HeroSection } from "@/components/custom/landing/hero-section"
import { TrustMetrics } from "@/components/custom/landing/trust-metrics"
import { ProductShowcase } from "@/components/custom/landing/product-showcase"
import { HowItWorks } from "@/components/custom/landing/how-it-works"
import { FeatureGrid } from "@/components/custom/landing/feature-grid"
import { CompetitorTable } from "@/components/custom/landing/competitor-table"
import { DemoBanner } from "@/components/custom/landing/demo-banner"
import { FinalCTA } from "@/components/custom/landing/final-cta"

export default function LandingPage() {
	return (
		<div className="flex-1 overflow-x-hidden">
			<HeroSection />
			<TrustMetrics />
			<ProductShowcase />
			<HowItWorks />
			<FeatureGrid />
			<CompetitorTable />
			<DemoBanner />
			<FinalCTA />
		</div>
	)
}
